










import { Component, Vue } from 'vue-property-decorator';
import Navbar from '@/components/Navbar.vue';
import MyFooter from '@/components/Footer.vue';
import BackTop from '@/components/BackTop.vue';

@Component({
  components: {
    Navbar,
    MyFooter,
    BackTop,
  },
})
export default class App extends Vue {
  private scroll = false;

  public created() {
    document.addEventListener('scroll', () => {
      this.scroll = ((document.documentElement.scrollTop ||
                      window.pageYOffset || document.body.scrollTop) > 100);
    });
  }
}
